<template>
	<div>
		<PageIntroSection :small-title="$t('about_0_title')">
			<template slot="left">
				<rr-animate-text
					:text-type="$const.HTML_CLASS.TEXT_TYPE.TITLE_PRIMARY_MEDIUM"
					:text-color="$const.HTML_CLASS.TEXT_COLOR.LIGHT"
					:scroll-animation-delay="0.25"
					>{{ $t("about_0_title_1") }}
				</rr-animate-text>
				<rr-animate-text
					:text-type="$const.HTML_CLASS.TEXT_TYPE.TITLE_PRIMARY_MEDIUM"
					:text-color="$const.HTML_CLASS.TEXT_COLOR.APP_PRIMARY"
					:scroll-animation-delay="0.35"
				>
					YaroFlasher<sup :class="$style['trademark']"
						><span>&trade;</span></sup
					>
				</rr-animate-text>
			</template>
			<template slot="right">
				<rr-animate-image
					:class="$style['big-logo-wrap']"
					file-name="logo-transparent.svg"
					:scroll-animation-delay="0.3"
				/>
			</template>
		</PageIntroSection>
		<rr-section>
			<container-two-cols :sec-title="$t('about_1_title')">
				<template slot="content">
					<column>
						<rr-animate-text
							:text-type="$const.HTML_CLASS.TEXT_TYPE.TEXT_PRIMARY_LARGE"
							:text-color="$const.HTML_CLASS.TEXT_COLOR.DARK"
							>{{ $t("about_1_text") }}
						</rr-animate-text>
					</column>
				</template>
			</container-two-cols>
		</rr-section>
		<rr-section>
			<rr-animate-image tag="container-inner" file-name="team.jpg" />
		</rr-section>
		<rr-section>
			<container-two-cols :sec-title="$t('about_2_title')">
				<template slot="content">
					<column :width="2">
						<rr-animate-text
							:text-color="$const.HTML_CLASS.TEXT_COLOR.DARK"
							:scroll-animation-delay="0.15"
							v-html="$t('about_2_text')"
						/>
					</column>
				</template>
			</container-two-cols>
		</rr-section>
		<rr-section
			:background-color="$const.HTML_CLASS.BACKGROUND_COLOR.LIGHT_GRAY"
		>
			<container-two-cols :sec-title="$t('about_3_title')">
				<template slot="content">
					<column>
						<rr-animate-text
							:text-color="$const.HTML_CLASS.TEXT_COLOR.DARK"
							:text-type="$const.HTML_CLASS.TEXT_TYPE.TITLE_PRIMARY_SMALL"
							:scroll-animation-delay="0.15"
							>{{ $t("about_3_text") }}
						</rr-animate-text>
					</column>
				</template>
			</container-two-cols>
			<container-inner :is-fluid="true">
				<rr-slider :slides="teamSlides" :class="$style['team-slider-wrap']" />
			</container-inner>
		</rr-section>
		<rr-section
			:background-color="$const.HTML_CLASS.BACKGROUND_COLOR.TRANSPARENT"
		>
			<container-two-cols
				:is-dark-title="false"
				:sec-title="$t('about_4_title')"
			>
				<template slot="content">
					<column>
						<rr-animate-text
							:text-color="$const.HTML_CLASS.TEXT_COLOR.LIGHT"
							:text-type="$const.HTML_CLASS.TEXT_TYPE.TITLE_PRIMARY_SMALL"
							:scroll-animation-delay="0.15"
							>{{ $t("about_4_text") }}
						</rr-animate-text>
						<award-table></award-table>
					</column>
				</template>
			</container-two-cols>
		</rr-section>
		<rr-section :class="$style['nav-section']">
			<container-two-cols :sec-title="$t('next')">
				<template slot="content">
					<column>
						<rr-animate-link-wrap
							href="/works"
							:text-type="$const.HTML_CLASS.TEXT_TYPE.TITLE_PRIMARY_LARGE"
							:text-color="$const.HTML_CLASS.TEXT_COLOR.TRANSPARENT_DARK"
							:scroll-animation-delay="0.15"
							>{{ $t("nav_works") }}&nbsp;<span
								v-html="
									require('!svg-inline-loader!@/assets/img/svg/link-arrow.svg')
								"
							/>
						</rr-animate-link-wrap>
					</column>
				</template>
			</container-two-cols>
		</rr-section>
	</div>
</template>

<script>
import AwardTable from "../components/about/AwardTable";
// import TeamStatic from "../components/about/TeamStatic"
import PageIntroSection from "../components/page/PageIntroSection";
import TeamSlideContent from "../components/about/TeamSlideContent";
import appearAfterLoadingAnimation from "../mixins/animations/appear-after-loading";
import team1Img from "@/assets/img/team-Yaroslav.jpg";
import team1HoverImg from "@/assets/img/team-Yaroslav-hover.jpg";
import team2Img from "@/assets/img/team-Ihor.jpg";
import team2HoverImg from "@/assets/img/team-Ihor-hover.jpg";
import team3Img from "@/assets/img/team-Vladimir.jpg";
import team3HoverImg from "@/assets/img/team-Vladimir-hover.jpg";
import team4Img from "@/assets/img/team-MaxM.jpg";
import team4HoverImg from "@/assets/img/team-MaxM-hover.jpg";
import team5Img from "@/assets/img/team-MaxK.jpg";
import team5HoverImg from "@/assets/img/team-MaxK-hover.jpg";

export default {
	name: "about",
	components: {
		PageIntroSection,
		AwardTable,
		// TeamStatic,
		// BigLogoWrap,
	},
	mixins: [appearAfterLoadingAnimation],
	metaInfo() {
		return {
			title: this.$t("nav_about"),
		};
	},
	data() {
		return {
			// slider
			teamSlides: [
				{
					component: TeamSlideContent,
					props: {
						index: 0,
						thumbnailImgSrc: team1Img,
						thumbnailImgHoverSrc: team1HoverImg,
						name: "Yaroslav Kononov",
						position: "CEO & Founder",
					},
				},
				{
					component: TeamSlideContent,
					props: {
						index: 1,
						thumbnailImgSrc: team2Img,
						thumbnailImgHoverSrc: team2HoverImg,
						name: "Ihor Karas",
						position: "Motion Designer",
					},
				},
				{
					component: TeamSlideContent,
					props: {
						index: 2,
						thumbnailImgSrc: team3Img,
						thumbnailImgHoverSrc: team3HoverImg,
						name: "Vladimir Liubarskiy",
						position: "Motion Designer",
					},
				},
				{
					component: TeamSlideContent,
					props: {
						index: 3,
						thumbnailImgSrc: team4Img,
						thumbnailImgHoverSrc: team4HoverImg,
						name: "Max Marakhovskyi",
						position: "Motion Designer",
					},
				},
				{
					component: TeamSlideContent,
					props: {
						index: 4,
						thumbnailImgSrc: team5Img,
						thumbnailImgHoverSrc: team5HoverImg,
						name: "Max Kravchenko",
						position: "Motion Designer",
					},
				},
			],
		};
	},
};
</script>

<style module lang="scss">
// big logo in first row
$logoMinusBottom: responsive-size-height-screen(170-125);
picture.big-logo-wrap {
	position: absolute;
	align-self: flex-end;
	margin-top: auto;
	top: 0;
	svg {
		width: responsive-size-width-screen(605);
		transform: translateY($logoMinusBottom);
	}
	// mobile
	@include breakpoint($mobileDesignBreakpoint) {
		display: none;
	}
}

// last row with next link
.nav-section {
	a {
		line-height: 1;
		// icon
		svg {
			height: 0.7em;
		}
	}
}
.trademark {
	margin-left: 10px;
	font-size: 28px;
	// mobile
	@include breakpoint($mobileDesignBreakpoint) {
		font-size: 20px;
	}
}
</style>
